import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { find } from 'lodash';

import Select from '../../../elements/Select';
import withLocalization from '../../../hoc/withLocalization';

const TasksWidgetMobx = inject('taskStore')(withLocalization(observer(class TasksWidgetMobx extends Component {
    notLoadedYet = true;

    constructor(props) {
        super(props);
        this.state = {
            page : 0
        };
        this.loadOptionsDebounced = null;
        this.currentInputValue = '';
    }

    componentWillReceiveProps(nextProps) {
        const cache = `${this.props.filterByUser} ${this.props.filterByProject}`;
        const ncache = `${nextProps.filterByUser} ${nextProps.filterByProject}`;
        if(!nextProps.filterByProject) return;
        if (cache !== ncache || this.notLoadedYet) {
            this.notLoadedYet = false;
            const userId = nextProps.filterByUser ? nextProps.filterByUser : undefined;
            const orderBy = nextProps.defaultByGeneric ? true : false;
            this.setState({ page : 0 });
            nextProps.taskStore.loadLookup(nextProps.filterByProject, userId, undefined, 0, orderBy, false).then(list => {
                const { value } = nextProps;
                const { defaultIfOne, defaultByGeneric } = nextProps;
                const options = this.prepareOptions(list);
                if (!options.length) return nextProps.onChange(null, null);
                const currentValueIsNotInOptions = !parseInt(value) || !options.some(ele => parseInt(ele.value) === parseInt(value));
                if ((defaultIfOne && currentValueIsNotInOptions && !nextProps.isShiftEdit) || (defaultByGeneric && nextProps.filterByProject && currentValueIsNotInOptions && !nextProps.isShiftEdit)) {
                    nextProps.onChange(options[0].value, options[0]);
                }
            });
        }
    }

    componentDidMount() {
        this.handleLoadInitialOptions();
    }

    handleLoadInitialOptions() {
        const { filterByProject , taskStore, filterByUser = undefined, defaultByGeneric, options } = this.props;
        if(!options?.fromAdditionalPaymentsForm && !filterByProject) return;
        this.currentInputValue = '';
        this.setState({ page:0 })
        const orderBy = defaultByGeneric ? true : false;
        taskStore.loadLookup(filterByProject, filterByUser, undefined, 0, orderBy, options?.fromAdditionalPaymentsForm)
    }
    
    componentWillUnmount() {
        if(this.loadOptionsDebounced) clearTimeout(this.loadOptionsDebounced);
    }

    loadOptions = (inputValue, callback) => {
        if(this.loadOptionsDebounced) clearTimeout(this.loadOptionsDebounced);
        const { taskStore, filterByProject , filterByUser = undefined, defaultByGeneric , options } = this.props;
        const orderBy = defaultByGeneric ? true : false;
        this.currentInputValue = inputValue;
        if(!options?.fromAdditionalPaymentsForm && !filterByProject) return;
        this.loadOptionsDebounced = setTimeout(() => {
            taskStore.loadLookup(filterByProject, filterByUser, inputValue, 0, orderBy, options?.fromAdditionalPaymentsForm).then((list)=>{
                const preparedOptions = this.prepareOptions(list);
                this.setState({ page : 0 });
                callback(preparedOptions);
            })
        }, 300)
    };

    handleInputChange = (newValue, actionMeta) => {
        if(actionMeta.action === 'input-change'){
            this.currentInputValue = newValue;
            this.setState({ page : 0 })
            return newValue;
        }
        return newValue;
    };
    

    handleMenuScrollToBottom = async () => {
        const { page } = this.state;
        const { taskStore, filterByProject , filterByUser = undefined, defaultByGeneric, options } = this.props;
        if(!options?.fromAdditionalPaymentsForm && !filterByProject) return;
        const hasMore = page + 1 < taskStore.currentTasksLookup.pages;
        const inputValue = this.currentInputValue ? this.currentInputValue : undefined;
        if(!hasMore) return;
        const nextPage = page + 1;
        const orderBy = defaultByGeneric ? true : false;
        await taskStore.loadLookup(filterByProject, filterByUser, inputValue, nextPage, orderBy, options?.fromAdditionalPaymentsForm);
        this.prepareOptions(taskStore.currentTasksLookup.rows);
        this.setState({ page : nextPage });
    }

     prepareOptions = array => {
        let _array = array;
        const prepareOptions = _array
            ? _array.map(pm => {
                return {
                    value: `${pm.id}`,
                    label: `${pm.task_number} | ${pm.name}`,
                };
            })
            : [];
        
        // Add insertFirst option at the beginning if provided
        const { options } = this.props;
        if (options && options.insertFirst) {
            prepareOptions.unshift({
                value: `${options.insertFirst.id}`,
                label: options.insertFirst.name,
            });
        }
        
        return prepareOptions;
    };

    render() {
        const { currentTasksLookup, loadingLookup } = this.props.taskStore;
        const {
            value,
            onChange,
            t,
            disabled,
            emptyOption,
            emptyOptionLabel,
            label = '',
            menuPlacement,
            maxMenuHeight,
        } = this.props;
        const options = this.prepareOptions(currentTasksLookup.rows);
        const currentSelect = find(options, o => {
            return String(o.value) === String(value);
        });
        const inputView = !!label;
        return (
            <div className={`managers-widget ${inputView ? 'input-block' : ''}`}>
                {inputView && <span className="input-block__label">{label}</span>}
                <Select
                    asyncSelect
                    options={options}
                    emptyOption={emptyOption}
                    inputView={inputView}
                    defaultOptions={options}
                    emptyOptionLabel={emptyOptionLabel}
                    value={currentSelect}
                    isDisabled={disabled}
                    isClearable={true}
                    placeholder={t('Select Task')}
                    onChange={(id) => {
                        if(!id || !id.value) {
                           this.handleLoadInitialOptions();
                        }
                        onChange(id?.value, id)
                    }}
                    style={{ width: '100%' }}
                    className={"custom-select-max-height-200"}
                    onMenuScrollToBottom={this.handleMenuScrollToBottom}
                    loadOptions={this.loadOptions}
                    isLoading={loadingLookup}
                    onInputChange={this.handleInputChange}
                    menuPlacement={menuPlacement}
                    maxMenuHeight={maxMenuHeight}
                />
            </div>
        );
    }
})));

export const TasksWidget = observer(class TasksWidget extends Component {
    render() {
        return <TasksWidgetMobx {...this.props} />;
    }
});
